import { useEffect } from "react";
import { track } from "@/lib/api";

// Reveals sections and records one section_view per section per page load.
export function useSectionObserver(ready) {
  useEffect(() => {
    if (!ready) return undefined;
    const seen = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          const id = entry.target.dataset.trackSection;
          if (id && !seen.has(id)) {
            seen.add(id);
            track("section_view", { section: id });
          }
        });
      },
      { rootMargin: "0px 0px -40% 0px", threshold: 0 },
    );
    document.querySelectorAll("[data-track-section]").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [ready]);
}
